import Vue from 'vue'
import router from './router'
import store from './store'
import { isInHomeRouters } from '@/utils/util'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { ACCESS_TOKEN } from '@/store/mutation-types'

import { homeRouterMap, constantRouterMap, projectRouterMap } from '@/config/router.config'

NProgress.configure({ showSpinner: true }) // NProgress Configuration
const whiteList = ['login', 'register', 'registerResult'] // no redirect whitelist
const cookie = Vue.ls

router.beforeEach((to, from, next) => {
  //NProgress.start() // start progress bar
  
  // 初始化query参数
  const hasRedirect = to.query.to
  const notRedirect = !!to.params.notRedirect
  const hasProjectId = to.query.project_id || store.getters.projectId
  const query = {}
  if (hasRedirect)query.to = hasRedirect
  if (hasProjectId) query.project_id = hasProjectId
  // 登录界面 不是从内容页跳转而来
  if (to.name == 'login' &&
    whiteList.includes(from.name) == false && // 不是从内容页跳转而来
    hasRedirect == undefined && // 需要在query上加上要去的页面
    notRedirect == false) { // 不是主动登出
    query.to = from.path
    return next({ name: 'login', query: query })
  }
  // 注册页面
  if (whiteList.includes(to.name)) return next()

  // 其它页面
  const hasLogined = !!store.getters.nickname
  // 未登录 刷新的情况，无用户信息但有token
  const toPath = to.path
  const token = cookie.get(ACCESS_TOKEN)
  if (hasLogined == false && !!token != null) {
    return new Promise((resolve) => {
      store.dispatch('GetUserInfo').then(permissions => {
        store.dispatch('GenerateHomeRoutes', permissions).then(() => {
          next({ path: toPath, query: query }) // 这里正常情况下query中不会有重定向
        })
      })
    }).catch(() => {
      Vue.$message.error('获取用户信息失败')
      store.dispatch('Logout')
    })
  }
  // token 过期
  if (token == null){
    query.to = to.path
    return next({ name: 'login', query: query })
  } 

  // 是到主页
  // 未加载主页路由
  if (isInHomeRouters(to.path)) {
    store.dispatch('ConvertPage', 'homePage') // 防止返回上一页时左侧菜单不变
    return next()
  }
  // 是到项目
  store.commit('CONVERT_PAGE', 'projectPage') // 防止返回上一页时左侧菜单不变
  // 初始化项目参数
  var oldProjectId = store.getters.projectId
  var newProjectId = to.query.project_id
  // 未加载项目路由（原本未保存projectId 有现在要进入的Id (如：刷新的情况)）
  if (oldProjectId == '' && newProjectId != undefined) {
    return store.dispatch('ToProject', {
      path: to.path,
      projectId: newProjectId,
      query: query
    }).catch(err => { store.dispatch('Logout') })
  }
  // 项目内部每次跳转都在url加上project_id
  if (newProjectId == undefined && oldProjectId != '') {
    return next({ path: to.path, query: query }) // query在前面已被加上project_id
  }

  // 正常情况
  next()
})

router.afterEach(() => {
  //debugger
  NProgress.done() // finish progress bar
})

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = Vue.directive('action', {
  bind: function (el, binding, vnode) {
    const actionName = binding.arg
    const roles = store.getters.roles
    const elVal = vnode.context.$route.meta.permission
    const permissionId = elVal instanceof String && [elVal] || elVal
    roles.permissions.forEach(p => {
      if (!permissionId.includes(p.permissionId)) {
        return
      }
      if (p.actionList && !p.actionList.includes(actionName)) {
        el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
      }
    })
  }
})

export {
  action
}

/*
if (to.path === '/user/login') {
      next()
    } else {
      if (store.getters.permissions.length === 0) {

        store.dispatch('GetUserInfo').then(permissions => {
          store.dispatch('GenerateHomeRoutes', permissions).then(() => {
            if(hasProjectId) store.dispatch('ConvertPage', 'projectPage')
            else store.dispatch('ConvertPage', 'homePage')
            next({ path: to.path, query: query })
          }).catch(err => {
            store.dispatch('Logout')
          })
        })
      } else {

        const projectId = store.getters.projectId
        if( to.query.project_id == undefined && hasProjectId) {
          next({ path: to.path, query: query })
        }else next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      next()
    } else {
      next({ path: '/user/login', query: query })
    } */
